module.exports = __webpack_public_path__ + "static/media/Suncorp_Primary_Thick.07b2271b.svg";